import {Component, OnInit} from '@angular/core';

import {UserCheckEntitlementsService} from '../user-check-entitlements/user-check-entitlements-service';

@Component({
  selector: 'aqx-user-check-entitlements',
  templateUrl: './user-check-entitlements.component.html',
  styleUrls: ['./user-check-entitlements.component.scss']
})
export class UserCheckEntitlementsComponent implements OnInit {

  constructor(
    private userCheckEntitlementsService: UserCheckEntitlementsService) {
  }

  ngOnInit() {
    this.userCheckEntitlementsService.checkEntitlements();
  }
}
